<template>
  <q-icon
    :name="icon"
    :title="platform"
    :class="cssClass"
    v-bind="$attrs"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { types } from '.';

const map:{[platform: string]: string} = {};
map[types.Facebook] = 'facebook';
map[types.Instagram] = 'instagram';

export default defineComponent({
  props: {
    platform: {
      type: String,
      required: true,
    },
    color: String,
  },
  computed: {
    icon(): string {
      return `fab fa-${map[this.platform]}`;
    },
    actualColor(): string {
      return this.color || this.platform.toLowerCase();
    },
    cssClass(): string {
      return `text-${this.actualColor}`;
    },
  },
});
</script>
